<gstar-grid
  dataIdKey="investmentJurisdictionId"
  [source]="source.items"
  [totalCount]="source.total"
  [lazy]="true"
  [drawerSetting]="drawerSetting"
  [headers]="headers"
  [searchSetting]="searchSetting"
  [query]="query"
  (queryChange)="queryHandler($event)"
  [showToolbarDownloadAllButton]="true"
  (toolbarDownloadAll)="onExportDownloadAll()"
  [showToolbarDownloadButton]="true"
  (toolbarDownload)="onExportDownload($event)"
  [noDataFilteredMessage]="
    'admin.dashboard.notFoundRecordsMessage' | translate
  " />
